import { render } from "./CustomPDFHeader.vue?vue&type=template&id=2770d454"
import script from "./CustomPDFHeader.vue?vue&type=script&lang=js"
export * from "./CustomPDFHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__